import CCPADataRequest from './ccpa_data_request';

export default CCPADataRequest;
